import { getBrandsByIds } from "@/requests/brand";
import useFetch from "./useFetch";

const useBrandsById = ({ widget }: { widget?: Widget }) => {
  const {
    response: brands,
    loading,
    error,
  } = useFetch(
    () => getBrandsByIds(widget?.brandList?.map((b) => b.id) || []),
    {}
  );

  return {
    brands,
    loading,
    error,
  };
};

const useBrandsByIdWithInterceptors = () => {
  return [];
};
// ** exports
export default useBrandsById;
export { useBrandsByIdWithInterceptors };
